import { config } from "../../../../../helpers/config_global";
import React, { Component, Fragment } from "react";
import {
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/organizationhistoriService";

import apiResponse from "../../../../../services/apiResponse";
import IndexBloc from "../Blocs/IndexBlock";
import MinioClient from "../../../../../services/minioClient";

class EmployeeTableComponent extends Component {
  indexBloc = new IndexBloc();
  minioClient = new MinioClient();
  source;
  historyTable = "EmployeePresensiTable";
  defaultOrder = "employee_name";
  defaultSize = 10;
  defaultSort = "asc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
      tokenAPICalled: false,
    };
  }
  loadData = async () => {
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      type: this.props.type,
    };
    await this.indexBloc.fetchEmployeeListWarning(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.indexBloc.employeewarningChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
  }

  componentDidUpdate(prevProps) {
    // Check if modal opened or a different row (employee_transfer_detail_uuid) is clicked
    if (
      this.props.modal &&
      (!prevProps.modal || prevProps.uuid !== this.props.uuid)
    ) {
      // Call the API only when modal opens or uuid changes
      this.setTokenAPI();
      this.setState({ tokenAPICalled: true });
    }
  }

  // componentDidUpdate(prevProps) {
  //   if (!prevProps.modal && this.props.modal && !this.state.tokenAPICalled) {
  //     // Only call setTokenAPI when modal transitions from false to true
  //     this.setTokenAPI();
  //     this.setState({ tokenAPICalled: true }); // Mark that token API was called
  //   }
  // }

  componentWillUnmount() {
    this.indexBloc.employeewarningChannel.unsubscribe();
  }

  columns = [
    {
      key: "employee_name",
      text: "Nama Pegawai",
      sortable: true,
      cell: "-",
    },

    {
      key: "employee_nip",
      text: "NIP",
      sortable: true,
      cell: "-",
    },

    {
      key: "position_name",
      text: "Jabatan",
      sortable: true,
      cell: "-",
    },
  ];

  previewDocument(url) {
    window.open(url, "_blank");
  }

  // previewDocumentMinio(urlPath) {
  //   this.setState({
  //     loading: true,
  //   });
  //   this.minioClient.get(urlPath).then((url) => {
  //     this.setState({
  //       loading: false,
  //     });
  //     window.open(url, "_blank");
  //     // alert(url)
  //   });
  // }

  render() {
    return (
      <Fragment>
        <Modal isOpen={this.props.modal} size="xl" toggle={this.props.toggle}>
          <ModalHeader toggle={this.props.toggle}>
            {this.props.type == 1 && <Label>Daftar Semua Pegawai </Label>}
            {this.props.type == 2 && <Label>Daftar Pegawai Cuti</Label>}
            {this.props.type == 3 && <Label>Daftar Pegawai Surat Tugas</Label>}
            {this.props.type == 4 && (
              <Label>Daftar Pegawai Tugas Belajar</Label>
            )}
            {this.props.type == 5 && (
              <Label>Daftar Pegawai yang harus Absen</Label>
            )}
            {this.props.type == 6 && (
              <Label>Daftar Pegawai yang sudah Absen</Label>
            )}
            {this.props.type == 7 && (
              <Label>Daftar Pegawai yang belum Absen</Label>
            )}
          </ModalHeader>
          <ModalBody>
            <hr></hr>
            <MKIDatatable
              className={this.configDatatable.tableClass}
              config={this.configDatatable}
              records={this.state.rows}
              columns={this.columns}
              dynamic={true}
              minWidth={1000}
              total_record={this.state.totalRow}
              initial={this.state.filter}
              onChange={(filter) => {
                this.setState(
                  {
                    loadingTable: true,
                    filter: filter,
                  },
                  function () {
                    this.setTokenAPI();
                  }
                );
              }}
              loading={this.state.loadingTable}
            />
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default EmployeeTableComponent;
